import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Set minimum app width */
  body {
    min-width: 320px;
    overflow-x: hidden;
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.font || 'sans-serif'};
    background: ${({ theme }) => theme.background || '#f4f4f4'};
    color: ${({ theme }) => theme.text || '#000'};
  }

  /* Box-sizing reset */
  *, *::before, *::after {
    box-sizing: border-box;
  }

  /* Remove default button styling */
  button {
    font-family: inherit;
  }
`;

export default GlobalStyle;
